import {
  Component,
  ViewChild,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Renderer2,
  inject,
} from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';
import { JoditAngularComponent, JoditAngularModule } from 'jodit-angular';
import { asyncScheduler, Subscription } from 'rxjs';
import { get, isEqual } from 'lodash';
import { FieldTypeConfig } from '@ngx-formly/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import 'jodit/esm/plugins/justify/justify.js';

@Component({
    selector: 'app-formly-field-richtext',
    template: `
    <jodit-editor
      class="outline-none"
      #editor
      [config]="config"
      (onChange)="change()"
    ></jodit-editor>
  `,
    styles: [
        `
      .outline-none {
        outline: none !important;
      }
    `,
    ],
    host: {
        '(focusin)': 'onFocusIn()',
        '(focusout)': 'onFocusOut()',
    },
    imports: [JoditAngularModule]
})
export class FormlyFieldRichTextComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy, AfterViewInit, MatFormFieldControl<any>
{
  @ViewChild('editor', { static: true }) editor: JoditAngularComponent;
  renderer = inject(Renderer2);
  config: {};
  isFocused = false;

  subscription = new Subscription();

  onFocusIn() {
    this.field.focus = true;
    this.stateChanges.next();
  }
  onFocusOut() {
    this.field.focus = false;
    if (this.editor?.value?.trim() === '<p><br></p>' && this.props?.required) {
      this.formControl.markAsTouched();
      this.formControl.markAsDirty();
      this.formControl.setErrors({ required: true });
    }
    this.stateChanges.next();
  }

  change() {
    this.formControl.setValue(this.editor.value);
    this.formControl.markAsTouched();
    this.formControl.markAsDirty();
  }

  ngOnInit() {
    this.config = this.getJoditConfig(this.props.readonly);

    this.subscription.add(
      this.formControl.valueChanges.subscribe((value) => {
        if (value === undefined || value === null) {
          this.editor.value = null;
          this.formControl.markAsUntouched();
          this.formControl.markAsPristine();
        }
        this.editor.value = value;
      })
    );

    this.subscription.add(
      this.formControl.root.valueChanges.subscribe((value) => {
        // weird hack to set the readonly state
        asyncScheduler.schedule(() => {
          this.toggleReadOnlyState(
            get(this, 'field.templateOptions.readonly', false)
          );
        });
      })
    );
  }

  ngAfterViewInit(): void {
    this.editor?.editor?.editor?.setAttribute('tabindex', '0');
  }

  private toggleReadOnlyState(isReadonly: boolean) {
    const newConfig = this.getJoditConfig(isReadonly);
    if (!isEqual(this.config, newConfig)) {
      this.config = newConfig;
    }
  }

  private getJoditConfig(isReadonly: boolean = false): {} {
    return {
      buttons: 'bold,italic,underline,|,paragraph,ul,ol,outdent,indent,|,align',
      showPlaceholder: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      showCharsCounter: false,
      minHeight: 150,
      toolbarAdaptive: false,
      readonly: isReadonly,
      allowTabNavigation: true,
      tabIndex: 0,
      controls: {
        align: {
          list: {
            left: 'Left',
            center: 'Center',
            right: 'Right'
          }
        }
      }
    };
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
